module.exports = __webpack_public_path__ + "img/Postmodernisme_Herbjorg-Wassmo.a8da6775.jpg";